import { MutationTree } from 'vuex';
import { StudyCalendarEventState } from './state';
import { CalendarEvent } from '@/models/undergrad/calendar-event.model';
import Vue from 'vue';

const mutations: MutationTree<StudyCalendarEventState> = {
  SET_STUDY_CALENDAR_EVENTS(
    state: StudyCalendarEventState,
    payload: { studyCalendarEvents: CalendarEvent[] },
  ): void {
    Vue.set(state, 'studyCalendarEvents', payload.studyCalendarEvents);
  },
  SET_IS_LOADING_STUDY_CALENDAR_EVENT_DATA(
    state: StudyCalendarEventState,
    payload: { isLoading: boolean },
  ): void {
    Vue.set(state, 'isLoadingStudyCalendarEventData', payload.isLoading);
  },
};

export default mutations;
